import React, { FunctionComponent } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { I18n } from '@aws-amplify/core';

import { AppDispatch, RootState } from "../../store/store";


import {
  Alert,
  Snackbar,
  Button,
  IconButton,
} from '@mui/material';

import { Close } from '@mui/icons-material';

import { closeFeedback, feedback } from './feedback';
import { useTranslation } from 'react-i18next';
import { push } from '@lagunovsky/redux-react-router';

import './Feedback.css';

interface Props {
}

const Feedback: FunctionComponent<Props> = ( props ) => {

  const message = useSelector( ( state: RootState ) => state.feedback.message );
  const open = useSelector( ( state: RootState ) => state.feedback.open );
  const severity = useSelector( ( state: RootState ) => state.feedback.severity );
  const action = useSelector( ( state: RootState ) => state.feedback.action );
  const path = useSelector( ( state: RootState ) => state.feedback.path );

  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation( [ 'api' ] );

  const onAction = () => {
    if( path ) {
      dispatch( push( path ) )
    }
    dispatch( closeFeedback() );
  }

  const onClose = () => {
    dispatch( closeFeedback() );
  }

  return (
    <div className="feedback">
      <Snackbar
        open={ open }
        anchorOrigin={ {horizontal: 'left', vertical: 'bottom' } }
        message={ t( message )}
        action={ action ?
          <Button
            color="inherit"
            size="small"
            onClick={ onAction }
          >{ t( action ) }</Button> : (
            <IconButton aria-label="delete" size="small" onClick={ onClose }>
              <Close fontSize="inherit" sx={ { color: 'white' }} />
            </IconButton>
          )}
      />
    </div>
  );
}

export default Feedback;

  // return (
  //   <div>
  //   { severity === 'default' ? (
  //     <Snackbar
  //       open={ open }
  //       anchorOrigin={ {horizontal: 'center', vertical: 'bottom' } }
  //       message={ t( message )}
  //       action={ action ?
  //         <Button
  //           color="inherit"
  //           size="small"
  //           onClick={ onAction }
  //         >{ t( action ) }</Button> : (
  //           <IconButton aria-label="delete" size="small" onClick={ onClose }>
  //             <Close fontSize="inherit" sx={ { color: 'white' }} />
  //           </IconButton>
  //         )}
  //     />
  //     ) : (
  //     <Snackbar
  //       open={ open }
  //     >
  //         <Alert
  //           severity={ severity }
  //           action={ action ?
  //             <Button
  //               color="inherit"
  //               size="small"
  //               onClick={ onAction }
  //             >{ t( action ) }</Button> : null }
  //           onClose={ onClose }
  //         >{ t( message ) }</Alert>
  //     </Snackbar>
  //     )}
  //   </div>
  // );
